import React from 'react';
import '../styles/github.css';

function PrivacyPolicy() {
  const [theme, setTheme] = React.useState('dark');

  React.useEffect(() => {
    const savedTheme = localStorage.getItem('memo_theme') || 'dark';
    setTheme(savedTheme);
    document.body.classList.add(savedTheme + '-theme');
  }, []);

  const toggleTheme = () => {
    const newTheme = theme === 'dark' ? 'light' : 'dark';
    setTheme(newTheme);
    localStorage.setItem('memo_theme', newTheme);
    document.body.classList.remove(theme + '-theme');
    document.body.classList.add(newTheme + '-theme');
  };

  return (
    <div style={styles.pageContainer}>
      {/* 主题切换按钮 */}
      <div className="theme-toggle" onClick={toggleTheme} style={styles.themeToggle}>
        {theme === 'dark' ? (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="#f5f0e6">
            <path d="M9.37 5.51c-.18.64-.27 1.31-.27 1.99 0 4.08 3.32 7.4 7.4 7.4.68 0 1.35-.09 1.99-.27C17.45 17.19 14.93 19 12 19c-3.86 0-7-3.14-7-7 0-2.93 1.81-5.45 4.37-6.49zM12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9 9-4.03 9-9c0-.46-.04-.92-.1-1.36-.98 1.37-2.58 2.26-4.4 2.26-2.98 0-5.4-2.42-5.4-5.4 0-1.81.89-3.42 2.26-4.4-.44-.06-.9-.1-1.36-.1z"/>
          </svg>
        ) : (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="#f9c796a4">
            <path d="M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zM2 13h2c.55 0 1-.45 1-1s-.45-1-1-1H2c-.55 0-1 .45-1 1s.45 1 1 1zm18 0h2c.55 0 1-.45 1-1s-.45-1-1-1h-2c-.55 0-1 .45-1 1s.45 1 1 1zM11 2v2c0 .55.45 1 1 1s1-.45 1-1V2c0-.55-.45-1-1-1s-1 .45-1 1zm0 18v2c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1s-1 .45-1 1zM5.99 4.58c-.39-.39-1.03-.39-1.41 0-.39.39-.39 1.03 0 1.41l1.06 1.06c.39.39 1.03.39 1.41 0 .39-.39.39-1.03 0-1.41L5.99 4.58zm12.37 12.37c-.39-.39-1.03-.39-1.41 0-.39.39-.39 1.03 0 1.41l1.06 1.06c.39.39 1.03.39 1.41 0 .39-.39.39-1.03 0-1.41l-1.06-1.06zm1.06-10.96c.39-.39.39-1.03 0-1.41-.39-.39-1.03-.39-1.41 0l-1.06 1.06c-.39.39-.39 1.03 0 1.41.39.39 1.03.39 1.41 0l1.06-1.06zM7.05 18.36c.39-.39.39-1.03 0-1.41-.39-.39-1.03-.39-1.41 0l-1.06 1.06c-.39.39-.39 1.03 0 1.41.39.39 1.03.39 1.41 0l1.06-1.06z"/>
          </svg>
        )}
      </div>

      <div style={styles.container}>
        <div className="card" style={styles.card}>
          <div style={styles.header}>
            <h1 style={styles.title}>MemoHub 隐私政策</h1>
            <p style={styles.subtitle}>最后更新日期：{new Date().toLocaleDateString('zh-CN')}</p>
          </div>

          <div style={styles.content}>
            <section style={styles.section}>
              <h2 style={styles.sectionTitle}>引言</h2>
              <p style={styles.paragraph}>
                感谢您选择 MemoHub。我们非常重视您的隐私。本隐私政策旨在向您说明我们如何收集、使用、存储和保护您的个人信息。请仔细阅读本政策。
              </p>
            </section>

            <section style={styles.section}>
              <h2 style={styles.sectionTitle}>1. 我们收集的信息</h2>
              
              <h3 style={styles.subSectionTitle}>1.1 您直接提供的信息</h3>
              <ul style={styles.list}>
                <li><strong>账户信息：</strong>注册时提供的用户名、邮箱地址、密码</li>
                <li><strong>备忘录内容：</strong>您创建的文本备忘录内容</li>
                <li><strong>手写数据：</strong>通过手写功能创建的手写备忘录（以Base64格式存储）</li>
                <li><strong>分类信息：</strong>您创建的备忘录分类及其设置</li>
              </ul>
              
              <h3 style={styles.subSectionTitle}>1.2 自动收集的信息</h3>
              <ul style={styles.list}>
                <li><strong>设备信息：</strong>设备类型、操作系统版本、浏览器类型</li>
                <li><strong>使用数据：</strong>访问时间、使用频率、功能使用情况</li>
                <li><strong>Cookies：</strong>用于保持登录状态和用户偏好的必要cookies</li>
              </ul>
            </section>

            <section style={styles.section}>
              <h2 style={styles.sectionTitle}>2. 我们如何使用您的信息</h2>
              <p style={styles.paragraph}>
                我们使用收集的信息用于以下目的：
              </p>
              <ul style={styles.list}>
                <li>提供、维护和改进 MemoHub 服务</li>
                <li>处理您的注册并管理您的账户</li>
                <li>在设备间同步您的备忘录数据</li>
                <li>发送重要的服务通知（如安全更新、服务条款变更）</li>
                <li>防止欺诈和滥用行为</li>
                <li>分析和改进服务性能</li>
              </ul>
            </section>

            <section style={styles.section}>
              <h2 style={styles.sectionTitle}>3. 数据存储和安全</h2>
              
              <h3 style={styles.subSectionTitle}>3.1 数据存储</h3>
              <p style={styles.paragraph}>
                您的数据存储在安全的服务器上。我们采用行业标准的安全措施来保护您的数据：
              </p>
              <ul style={styles.list}>
                <li>数据库加密存储</li>
                <li>HTTPS 加密传输</li>
                <li>密码哈希存储（我们无法查看您的明文密码）</li>
                <li>定期安全审计</li>
              </ul>
              
              <h3 style={styles.subSectionTitle}>3.2 数据保留</h3>
              <p style={styles.paragraph}>
                只要您的账户处于活跃状态，我们就会保留您的数据。如果您删除账户，我们将在30天内从活动数据库中删除您的个人信息。部分日志数据可能会保留更长时间用于安全审计目的。
              </p>
            </section>

            <section style={styles.section}>
              <h2 style={styles.sectionTitle}>4. 数据共享和披露</h2>
              <p style={styles.paragraph}>
                我们不会出售、交易或出租您的个人信息给第三方。只有在以下情况下，我们可能会共享您的信息：
              </p>
              <ul style={styles.list}>
                <li><strong>法律要求：</strong>应法律要求或响应法律程序时</li>
                <li><strong>保护权利：</strong>为保护 MemoHub、用户或公众的权利、财产或安全</li>
                <li><strong>服务提供商：</strong>与协助我们运营服务的受信任第三方（如云服务提供商），但他们会受到严格的保密协议约束</li>
              </ul>
            </section>

            <section style={styles.section}>
              <h2 style={styles.sectionTitle}>5. 您的权利</h2>
              <p style={styles.paragraph}>
                您对自己的数据拥有以下权利：
              </p>
              <ul style={styles.list}>
                <li><strong>访问权：</strong>访问我们持有的您的个人信息</li>
                <li><strong>更正权：</strong>更正不准确或不完整的个人信息</li>
                <li><strong>删除权：</strong>请求删除您的个人信息</li>
                <li><strong>导出权：</strong>获取您的数据副本</li>
                <li><strong>账户管理：</strong>随时可以登录账户修改个人信息或删除账户</li>
              </ul>
              <p style={styles.paragraph}>
                如需行使这些权利，请联系：166217228@qq.com
              </p>
            </section>

            <section style={styles.section}>
              <h2 style={styles.sectionTitle}>6. 儿童隐私</h2>
              <p style={styles.paragraph}>
                MemoHub 不面向13岁以下儿童。如果我们发现无意中收集了13岁以下儿童的个人信息，我们将尽快删除这些信息。
              </p>
            </section>

            <section style={styles.section}>
              <h2 style={styles.sectionTitle}>7. 国际数据传输</h2>
              <p style={styles.paragraph}>
                我们的服务器可能位于您所在国家/地区之外。通过使用我们的服务，您同意将您的信息传输到这些服务器并进行处理。
              </p>
            </section>

            <section style={styles.section}>
              <h2 style={styles.sectionTitle}>8. Cookies 和类似技术</h2>
              <p style={styles.paragraph}>
                我们使用必要的cookies来：
              </p>
              <ul style={styles.list}>
                <li>保持您的登录状态</li>
                <li>记住您的主题偏好</li>
                <li>提供基本的服务功能</li>
              </ul>
              <p style={styles.paragraph}>
                您可以通过浏览器设置控制cookies，但禁用cookies可能会影响某些功能的使用。
              </p>
            </section>

            <section style={styles.section}>
              <h2 style={styles.sectionTitle}>9. 政策变更</h2>
              <p style={styles.paragraph}>
                我们可能会不时更新本隐私政策。如果进行重大变更，我们会在网站上发布通知，并在可能的情况下通过电子邮件通知您。
              </p>
            </section>

            <section style={styles.section}>
              <h2 style={styles.sectionTitle}>10. 联系我们</h2>
              <p style={styles.paragraph}>
                如果您对本隐私政策有任何疑问或担忧，请通过以下方式联系我们：
              </p>
              <div style={styles.contactBox}>
                <p><strong>邮箱：</strong>166217228@qq.com</p>
                <p><strong>响应时间：</strong>我们将在收到问题后48小时内回复</p>
              </div>
            </section>

            <div style={styles.footer}>
              <button 
                onClick={() => window.history.back()}
                className="btn btn-primary"
                style={styles.backButton}
              >
                返回
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const styles = {
  pageContainer: {
    minHeight: '100vh',
    backgroundColor: 'var(--color-bg-secondary)',
    padding: '20px',
  },
  themeToggle: {
    position: 'fixed',
    top: '20px',
    right: '20px',
    zIndex: 100,
    background: 'rgba(255, 255, 255, 0.15)',
    backdropFilter: 'blur(10px)',
    WebkitBackdropFilter: 'blur(10px)',
    border: '1px solid rgba(255, 255, 255, 0.2)',
    borderRadius: '50%',
    width: '50px',
    height: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
  },
  container: {
    maxWidth: '900px',
    margin: '60px auto 40px',
  },
  card: {
    padding: '40px',
  },
  header: {
    textAlign: 'center',
    marginBottom: '40px',
    borderBottom: '2px solid var(--color-border-primary)',
    paddingBottom: '20px',
  },
  title: {
    fontSize: '32px',
    fontWeight: '700',
    color: 'var(--color-text-primary)',
    marginBottom: '10px',
  },
  subtitle: {
    fontSize: '14px',
    color: 'var(--color-text-tertiary)',
  },
  content: {
    fontSize: '15px',
    lineHeight: '1.7',
  },
  section: {
    marginBottom: '30px',
  },
  sectionTitle: {
    fontSize: '20px',
    fontWeight: '600',
    color: 'var(--color-text-primary)',
    marginBottom: '15px',
    paddingBottom: '8px',
    borderBottom: '1px solid var(--color-border-primary)',
  },
  subSectionTitle: {
    fontSize: '17px',
    fontWeight: '500',
    color: 'var(--color-text-primary)',
    margin: '15px 0 10px',
  },
  paragraph: {
    marginBottom: '15px',
    color: 'var(--color-text-secondary)',
  },
  list: {
    paddingLeft: '20px',
    marginBottom: '15px',
    color: 'var(--color-text-secondary)',
  },
  contactBox: {
    backgroundColor: 'var(--color-bg-secondary)',
    padding: '20px',
    borderRadius: '8px',
    border: '1px solid var(--color-border-primary)',
    marginTop: '10px',
  },
  footer: {
    marginTop: '40px',
    textAlign: 'center',
    paddingTop: '20px',
    borderTop: '1px solid var(--color-border-primary)',
  },
  backButton: {
    padding: '12px 30px',
    fontSize: '16px',
  },
};

export default PrivacyPolicy;